
import { defineComponent, PropType } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'

// types
import { SecurityAutoInformation } from '@/core/types/security.types'

export default defineComponent({
    components: {
        'the-button': TheButton,
    },
    props: {
        auto: {
            type: Object as PropType<SecurityAutoInformation>,
            required: true,
        },
        autoNumber: {
            type: String,
            default: null,
        },
        autoTechnicalPassport: {
            type: String,
            default: null,
        },
        isDeclineLoading: {
            type: Boolean,
            default: false,
        },
        isConfirmLoading: {
            type: Boolean,
            default: false,
        },
        isCanConfirm: {
            type: Boolean,
            default: false,
        },
        isCanDecline: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['decline', 'confirm'],
    setup(props, { emit }) {
        const onDecline = () => {
            emit('decline', props.auto)
        }

        const onConfirm = () => {
            // const answer = confirm(
            //     `Вы действительно хотите разрешить авто ${props.autoNumber || ''}?`
            // )
            // if (!answer) return

            emit('confirm', props.auto)
        }

        return {
            onDecline,
            onConfirm,
        }
    },
})
